import React from 'react';

function PrivacyLogin(props) {
    return (
        <div className="ghost-privacy-main-body">
            {props.regState === 0  ?
                <React.Fragment>
                    <div onClick={() => props.setRegState(1)} className="ghost-privacy-main-block">
                        <div className="ghost-privacy-main-block-icon">?</div>
                        <div className="ghost-privacy-main-block-text">
                            <span className="ghost-privacy-main-block-text-title">Create new wallet </span>
                            <span>Nothing connects new keys with you, your machine, or any other keys that you have.</span>
                        </div>
                    </div>
                    <div onClick={() => props.setRegState(2)} className="ghost-privacy-main-block">
                        <div className="ghost-privacy-main-block-text">
                            <span className="ghost-privacy-main-block-text-title">Import wallet </span>
                            <span>If you have keys, just use them in current application and remove any time you want</span>
                        </div>
                        <div className="ghost-privacy-main-block-icon">?</div>
                    </div>
                </React.Fragment>
                :
                props.regState === 1 ?
                <div className="ghost-privacy-create-wallet">
                    <div className="ghost-privacy-create-wallet-text">
                        <div className="ghost-privacy-create-wallet-text-title">Register new account</div>
                        <div className="ghost-privacy-create-wallet-text-text">This private key is for the access of {props.asset} account. It cannot be used to access any other Astral account. In order to register Key tx should happen, but you can deposit, withdraw and transact with any other account.</div>
                        <div className="ghost-claim-asset-text-box">
                            <input value={props.secret} onChange={(event) => props.setSecret(event.target.value)} spellCheck="false" type="text" placeholder="Enter your secret secret"></input>
                        </div>
                    </div>
                    <div className="ghost-propose-claim-buttons">
                        <div onClick={() => {props.setSecret(""); props.setRegState(0)}} className="ghost-propose-claim-buttons-button">Back</div>
                        <div onClick={() => {alert("generated key " + props.secret); props.setLogged(true); props.setRegState(0); props.setStep(2)}} className="ghost-propose-claim-buttons-button">Register</div>
                    </div>

                </div>
                :
                <div className="ghost-privacy-create-wallet">
                    <div className="ghost-privacy-create-wallet-text">
                        <div className="ghost-privacy-create-wallet-text-title">Import Account</div>
                        <div className="ghost-privacy-create-wallet-text-text">In order to import account enter your secret. Only works for previously registered accounts.</div>
                        <div className="ghost-claim-asset-text-box">
                            <input value={props.secret} onChange={(event) => props.setSecret(event.target.value)} spellCheck="false" type="text" placeholder="Enter your secret secret"></input>
                        </div>
                    </div>
                    <div className="ghost-propose-claim-buttons">
                        <div onClick={() => {props.setSecret(""); props.setRegState(0)}} className="ghost-propose-claim-buttons-button">Back</div>
                        <div onClick={() => {alert("generated key " + props.secret); props.setLogged(true); props.setRegState(0); props.setStap(2)}} className="ghost-propose-claim-buttons-button">Login</div>
                    </div>

                </div>
            }
        </div>
    )
}

export default PrivacyLogin;
